import FooterLinks from '../FooterLinks/FooterLinks';
import StyledSecondaryFooter from './StyledSecondaryFooter';

interface SecondaryFooterProps {
  justifyContent?: string;
}

const SecondaryFooter = ({
  justifyContent = 'space-between',
}: SecondaryFooterProps): JSX.Element => {
  return (
    <StyledSecondaryFooter>
      <FooterLinks
        justifyContent={justifyContent}
        color="var(--secondary-text-color)"
      />
    </StyledSecondaryFooter>
  );
};

export default SecondaryFooter;
